import { configureStore } from '@reduxjs/toolkit';
import landListingsReducer from './slices/landListingsSlice';
import landDetailsReducer from './slices/landDetailsSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    landListings: landListingsReducer,
    landDetails: landDetailsReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
